import React from "react";
import styled from "styled-components";

const StyledStripeDisclaimer = styled.div`
  color: ${(props) => props.theme.palette.primary.light};
  font-weight: 500;
  font-size: 16px;

  padding-top: 0.5vh;
  padding-bottom: 2vh;
`;

const StripeDisclaimer = () => {
  return <StyledStripeDisclaimer>Powered by Stripe</StyledStripeDisclaimer>;
};

export default StripeDisclaimer;
